// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3sHbG","title":"Images90_title__u99H8","images":"Images90_images__3MBIB"};